var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Chat")]),_vm._l((_vm.filteredMessages),function(message){return _c('chat-message',{attrs:{"user":message.ime,"content":message.sadrzaj}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }